import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M512 1024A512 512 0 0115.36 388.267 512 512 0 01950.613 248.32a508.16 508.16 0 0158.027 387.413A512 512 0 01512 1024zm0-998.4a486.4 486.4 0 00-117.76 958.293A486.4 486.4 0 00983.893 629.76 486.4 486.4 0 00629.76 40.107 488.96 488.96 0 00512 25.6zM509.44 768v85.333h-42.667V768h-121.6V250.88h119.894v-99.413h42.666V252.16a213.333 213.333 0 0189.6 16.213A79.36 79.36 0 01634.88 307.2a120.747 120.747 0 0113.653 55.467 132.267 132.267 0 01-46.08 104.106 246.187 246.187 0 01-42.666 29.44 152.747 152.747 0 0189.6 58.454 120.32 120.32 0 0119.2 70.826 144.64 144.64 0 01-17.92 71.254 128 128 0 01-49.067 50.346A179.2 179.2 0 01509.44 768zm-42.667-465.067h-59.306V473.6h58.026zm-59.306 224v189.014h58.026V526.933zm101.973-55.04a106.667 106.667 0 0036.267-14.08A80.213 80.213 0 00576 420.693a112.213 112.213 0 0012.373-48.213 64 64 0 00-22.613-49.92 89.173 89.173 0 00-56.32-19.627zm0 57.174v186.88a130.133 130.133 0 0042.667-6.4 81.92 81.92 0 0029.866-18.347 85.333 85.333 0 0023.04-59.733 96.853 96.853 0 00-14.08-50.774 98.987 98.987 0 00-42.666-35.84 180.907 180.907 0 00-38.827-15.36z"
});

function SvgThb(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "THB_svg__icon",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThb);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'THBOutlined';

export default KuFoxIcons;
